import { Button } from '@synergy-marine-group/synergy-ui';
import React from 'react';
import Modal from 'react-responsive-modal';
import { deleteModalStyles } from './styles';

const ConfirmShortClose = ({
    modal, setModal, handleDelete, handleCancel, message, data,
    shortCloseReason, setShortCloseReason }) => {
  const cancelFunction = () => {
    setShortCloseReason('');
    if (handleCancel) {
      handleCancel();
    } else {
      setModal(false);
    }
  };
  return (
    <Modal
    open={modal}
    onClose={() => setModal(false)}
    closeOnOverlayClick={false}
    center
    showCloseIcon={false}
    styles={deleteModalStyles}
    >
      <div className="w-auto py-8 px-8 font-muli ">
        <div className="align-middle align-center text-center">
          <h2 className="uppercase text-center font-montserrat pb-8 font-bold">
Confirm
{' '}
{message}
          </h2>
          <div className="font-normal pb-8">
Are you sure want to
{' '}
{message}
{' '}
{data
? (
<span>
{' '}
- PO
{' '}
{data}
{' '}
</span>
) : null}
?
          </div>
          {/* reason for shortclose its mandatory */}
            <div className="font-normal pb-8">
            <label className="font-normal ">Reason for Short Close:</label>
            <input
            type="text"
            id="reson"
            value={shortCloseReason}
            placeholder="Enter the reason for short close here"
            className="border border-gray-400 rounded-md w-full pt-2 mt-2"
            onChange={(e) => (e.target.value[0] === ' ' ? null : setShortCloseReason(e.target.value))}
            maxLength="250"
            />
            {/* error div showing character is more than 250 */}
            {shortCloseReason.length >= 250 ? (
            <div className="text-red-500 text-sm pt-2 text-left">Character limit is 250</div>
            ) : null}
            </div>
          <div className="flex justify-between">
            <Button
              className="max-w-none font-montserrat text-gray-500 uppercase text-sm"
              onClick={cancelFunction}
              size="large"
              variant="outlined"
              rounded
            >
              Cancel
            </Button>

            <Button
              className="max-w-none font-montserrat text-gray-500 uppercase text-sm"
              onClick={handleDelete}
              size="large"
              variant=" filled"
              disabled={shortCloseReason === ''}
              rounded
            >
              {message}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmShortClose;
